export default __webpack_public_path__ + "static/media/login-background.f385c63d.png";